export const getFloorName = (floorNo: number, settings: any) => {
  if (floorNo > 0) return floorNo;
  else if (floorNo === 0) return settings?.floorName?.ground_floor || 'GF';
  else if (floorNo === -1) return settings?.floorName?.basement || 'B';
  else return `${settings?.floorName?.sub_basement || 'SB'} ` + (Math.abs(floorNo) - 1);
};
